import React, { useState } from "react";
import {
  AttendancePolicyTable,
  SalaryCalculationPolicyTable,
  SalaryDeductionPolicyTable,
  SalaryStructureFormatTable,
  SalaryStructureHeadingTable,
  WeeklyOffPolicyTable,
} from "./Organizationtables";
import { SeprationFormatsTable, SettlementFormatsTable } from "../SeprationManagement/SeprationTables";
import { AppraisalParameterHeadings, AppraisalParameterType, AppraisalRating } from "../AppraisalManagement/AppraisalTables";



const OrgPolicies = () => {
  const [toggleState, setToggleState] = useState(1);

  return (
    <>
      <div>
        <div>
          <div className="bloc-tabs-with-white-bg">
            <button
              className={
                toggleState === 1
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(1)}
            >
              Attendace Policy
            </button>

            <button
              className={
                toggleState === 2
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(2)}
            >
              Weekly Off Policy
            </button>

            <button
              className={
                toggleState === 3
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(3)}
            >
              Salary Structure Headings
            </button>
            <button
              className={
                toggleState === 4
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(4)}
            >
              Salary Structure Formats
            </button>

            <button
              className={
                toggleState === 7
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(7)}
            >
              Separation Formats
            </button>
            <button
              className={
                toggleState === 8
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(8)}
            >
              Settlement Formats
            </button>
            <button
              className={
                toggleState === 9
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(9)}
            >
              Appraisal Parameter Type
            </button>
            <button
              className={
                toggleState === 10
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(10)}
            >
              Appraisal Parameter Heading
            </button>

            <button
              className={
                toggleState === 11
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(11)}
            >
              Appraisal Rating
            </button>


          </div>
        </div>

        <div className="content-tabs-without-margin">

          {toggleState === 1 ? <AttendancePolicyTable /> : null}

          {toggleState === 2 ? <WeeklyOffPolicyTable /> : null}

          {toggleState === 3 ? <SalaryStructureHeadingTable /> : null}

          {toggleState === 4 ? <SalaryStructureFormatTable /> : null}


          {toggleState === 7 ? <SeprationFormatsTable /> : null}

          {toggleState === 8 ? <SettlementFormatsTable /> : null}

          {toggleState === 9 ? <AppraisalParameterType /> : null}

          {toggleState === 10 ? <AppraisalParameterHeadings /> : null}

          {toggleState === 11 ? <AppraisalRating /> : null}

        </div>
      </div>
    </>
  );
};

export default OrgPolicies;